// extracted by mini-css-extract-plugin
export default {"container":"MainPageLayout_container__lLKOu"};